import { AssetFile } from 'contentful';
import NextImage, { ImageLoaderProps } from 'next/image';
import { Source } from '../../../../components/NextImage/Source';
import {
  ContentfulResizeTypes,
  getContentfulLoader,
} from '../../../../helpers/imageLoaders/contentful';

interface IProps {
  logoTitle: string;
  logoDesktop: AssetFile;
  logoMobile?: AssetFile;
}

export const CMSPartnerLogo = ({ logoTitle, logoDesktop, logoMobile }: IProps) => {
  if (!logoMobile) {
    return (
      <NextImage
        className="hidden w-full object-cover sm:flex"
        src={logoDesktop.url}
        loader={({ src, width, quality }: ImageLoaderProps): string =>
          getContentfulLoader(
            src,
            width,
            logoDesktop.details.image?.width ?? 0,
            logoDesktop.details.image?.height,
            {
              quality,
              resize: ContentfulResizeTypes.FILL,
            },
          )
        }
        alt={logoTitle}
        width={logoDesktop.details.image?.width}
        height={logoDesktop.details.image?.height}
        sizes="(min-width: 1280px) 420px,
                  (min-width: 600px) 50vw,
                  100vw"
      />
    );
  }

  return (
    <picture>
      <Source
        loader={({ src, width, quality }: ImageLoaderProps): string =>
          getContentfulLoader(
            src,
            width,
            logoDesktop.details.image?.width ?? 0,
            logoDesktop.details.image?.height,
            {
              quality,
              resize: ContentfulResizeTypes.FILL,
            },
          )
        }
        media="(min-width: 600px)"
        src={logoDesktop.url}
        sizes="(min-width: 1280px) 420px,
                  (min-width: 600px) 50vw,
                  100vw"
      />
      <NextImage
        className="w-full object-cover"
        src={logoMobile.url}
        loader={({ src, width, quality }: ImageLoaderProps): string =>
          getContentfulLoader(
            src,
            width,
            logoMobile.details.image?.width ?? 0,
            logoMobile.details.image?.height,
            {
              quality,
              resize: ContentfulResizeTypes.FILL,
            },
          )
        }
        alt={logoTitle}
        width={logoMobile.details.image?.width}
        height={logoMobile.details.image?.height}
        sizes="(min-width: 1280px) 420px,
                  (min-width: 600px) 50vw,
                  100vw"
      />
    </picture>
  );
};
